import React from 'react';

interface PrintSurveyChartProps {
  title?: string;
  instruction?: string;
  xAxisLabel?: string;
  yAxisLabel?: string;
  columnCount?: number;
  maxTicks?: number;
  showTitle?: boolean;
  hint?: string;
}

export function PrintSurveyChart({
  title = 'Gráfico de barras',
  instruction,
  xAxisLabel = 'Opciones de respuesta',
  yAxisLabel = 'Cantidad',
  columnCount = 4,
  maxTicks = 10,
  showTitle = true,
  hint = 'Escribe el nombre de cada opción debajo y pinta la altura de cada barra según la cantidad de votos.',
}: PrintSurveyChartProps) {
  const ticks = Array.from({ length: maxTicks + 1 }, (_, index) => maxTicks - index);
  const columns = Math.min(Math.max(columnCount, 3), 6);

  return (
    <div className="print-survey-chart">
      {instruction ? <p className="print-survey-chart__instruction">{instruction}</p> : null}
      {showTitle && title ? <p className="print-survey-chart__title">{title}</p> : null}
      <div className="print-survey-chart__frame">
        <div className="print-survey-chart__y-label">{yAxisLabel}</div>
        <div className="print-survey-chart__plot">
          <div className="print-survey-chart__y-axis">
            {ticks.map((tick) => (
              <span key={tick} className="print-survey-chart__tick">
                {tick}
              </span>
            ))}
          </div>
          <div
            className="print-survey-chart__grid"
            style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
          >
            {Array.from({ length: columns }, (_, index) => (
              <div key={index} className="print-survey-chart__column">
                <div className="print-survey-chart__bar-slot" aria-hidden />
                <span className="print-survey-chart__label-slot" aria-hidden />
                <span className="print-survey-chart__option-num">Opción {index + 1}</span>
              </div>
            ))}
          </div>
        </div>
        <p className="print-survey-chart__x-label">{xAxisLabel}</p>
      </div>
      <p className="print-survey-chart__hint">{hint}</p>
    </div>
  );
}
